import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCountUp } from 'react-countup';

export default function CountUpComponent({ endNumber, numberContainerClassName, numberClassName }) {
  if (!endNumber) endNumber = 30000;

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const { countUp, start } = useCountUp({
    start: endNumber / 2,
    end: endNumber,
    duration: 3,
  });

  useEffect(() => {
    if (inView) {
      start();
    }
  }, [inView]);

  const countUpWithCommas = countUp && countUp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if(!countUpWithCommas) return null

  return (
    <div ref={ref} className="flex -ml-2">
      {countUpWithCommas.split('').map((number, i) => (
        <div key={`counterNumber${i}`} className={`flex items-center justify-between ${numberContainerClassName}`}>
          <div className={`flex w-full font-bold tracking-2 font-heading${numberClassName}`}>
            <div className="mx-auto">{number}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
